import { FunctionComponent } from "react";
import { Section, Tile } from "@Types/pagify";
import "./style.scss";

export const ProductDescription: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  return (
    <div className="ProductDescription">
      <h2 className="ProductDescription-title">{section.title}</h2>
      <div className="ProductDescription-items">
        {tiles.map((tile) => {
          const text = tile.textBlock1 && tile.textBlock1[0].text;

          if (!!text) {
            return (
              <div
                className="ProductDescription-item"
                dangerouslySetInnerHTML={{ __html: text }}
                key={tile.slug}
              />
            );
          } else return null;
        })}
      </div>
    </div>
  );
};
